module.exports = __webpack_public_path__ + "static/media/xml.e0909347.svg";